import { Chip } from '@mui/material';
import { FC } from 'react';

const statusChipMap: Record<
  string,
  {
    variant: 'purple' | 'yellow' | 'blue' | 'green' | 'red';
    label: string;
  }
> = {
  checkoutinprogress: { variant: 'purple', label: 'Complete Purchase' },
  pendingconsumer: { variant: 'yellow', label: 'Info Required' },
  pendinglender: { variant: 'blue', label: 'Review in Progress' },
  approved: { variant: 'blue', label: 'Approved' },
  settle: { variant: 'green', label: 'Settled' },
  authorize: { variant: 'blue', label: 'Authorized' },
  refund: { variant: 'red', label: 'Refunded' },
  void: { variant: 'red', label: 'Voided' },
  chargeback: { variant: 'red', label: 'Chargeback' },
  reversal: { variant: 'yellow', label: 'Reversal' },
};

type StatusChipProps = {
  status: string;
};

const StatusChip: FC<StatusChipProps> = ({ status }) => {
  if (!status) return null;
  const updatedStatus = status.toLowerCase();
  if (!statusChipMap[updatedStatus]) return null;
  return <Chip {...statusChipMap[updatedStatus]} data-testid="status-chip" />;
};

export default StatusChip;
